import React, {Component} from 'react';
import Download from '../../../../Resources/Images/download.svg';
import './DocumentResult.css';
import Placeholder from "../../../../Resources/Images/16x9.png";

class DocumentResult extends Component {
    constructor(props) {
        super(props);
        this.downloadFile = this.downloadFile.bind(this);
    }

    downloadFile(e,file) {
        e.preventDefault();
        this.props.setFile(file);
        this.props.changeRoute('PDF');
    }

    render() {
        if(this.props.document.format === 'pdf') {
            return <tr className="DocumentResult" data-uid={this.props.document.id}>
                <td className="spacing"><a href="" onClick={(event) => this.downloadFile(event, this.props.document.url)}>{this.props.document.title}</a></td>
                <td className="spacing hidden-xs">{this.props.document.format}</td>
                <td className="spacing hidden-xs">{this.props.document.size}</td>
                <td className="spacing"><a href="" onClick={(event) => this.downloadFile(event, this.props.document.url)}><img src={Download} alt="Download" /></a></td>
            </tr>
        }else if(this.props.document.format === 'youtube') {
            var widget = 'widget' + this.props.document.id;
            var src = "https://www.youtube.com/embed/" + this.props.document.yid + "?rel=0&iv_load_policy=0&h1=de&controls=2&color=white&autoplay=0&fs=1&playsinline=1&origin=" + window.location.hostname + "&enablejsapi=1&widgetid=" + this.props.document.id;

            return <tr className="DocumentResult" data-uid={this.props.document.id}>
                <td colSpan="4">
                    <div className="video-wrapper">
                        <iframe
                            frameBorder="0"
                            allowFullScreen="1"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            title={this.props.document.title} width="1920" height="1080"
                            src={src}
                            id={widget}/>
                        <img src={Placeholder} alt="resolution-adjuster" className="resolution-adjuster" />
                    </div>
                </td>
            </tr>
        }
        return null;
    }
}

export default DocumentResult;


// WEBPACK FOOTER //
// ./src/Components/Search/SearchResult/DocumentResult/DocumentResult.js